// extracted by mini-css-extract-plugin
export default {"error-screen":"ErrorScreen-module__error-screen___i7fdY","container":"ErrorScreen-module__container___t6pEd"};